import ShippingMethodItems from 'components/FrictionlessCheckout/ShippingMethods/ShippingMethodItems/ShippingMethodItems';

export default ShippingMethodItems;
